export default __webpack_public_path__ + "674fa65906bc9f409b20bd6828fd1418.svg";